import { z } from 'zod';

const musicalToken = z.enum(['W', 'H', 'Q', 'E', 'S', 'R_Q']);
const timeSignature = z.enum(['3/4', '2/4', '4/4']);

/** Contrato estricto para bloques rítmicos en modo repertorio. */
export const MusicRhythmBlockSchema = z.object({
  title: z.string().min(1),
  timeSignature,
  targetBarNumber: z.number().int().min(1).optional(),
  /** Tokens puros del compás real — alias aceptado desde Mistral. */
  originalBarTokens: z.array(musicalToken).min(1).optional(),
  patternTokens: z.array(musicalToken).min(1).optional(),
  exerciseType: z
    .enum(['identify_missing', 'order_steps', 'dictation', 'match', 'identify', 'complete'])
    .optional(),
  taskKind: z.enum(['complete', 'order', 'identify', 'match', 'practice']).optional(),
  questionText: z.string().optional(),
  prompt: z.string().optional(),
  missingIndex: z.number().int().min(0).optional(),
});

export type MusicRhythmBlockInput = z.infer<typeof MusicRhythmBlockSchema>;

export function parseMusicRhythmBlock(raw: unknown): MusicRhythmBlockInput | null {
  const result = MusicRhythmBlockSchema.safeParse(raw);
  return result.success ? result.data : null;
}

export function exerciseTypeToTaskKind(
  exerciseType?: MusicRhythmBlockInput['exerciseType'],
  taskKind?: MusicRhythmBlockInput['taskKind'],
): 'complete' | 'order' | 'identify' | 'match' | 'practice' {
  if (taskKind) return taskKind;
  switch (exerciseType) {
    case 'order_steps':
      return 'order';
    case 'dictation':
      return 'practice';
    case 'match':
      return 'match';
    case 'identify':
    case 'identify_missing':
      return 'complete';
    default:
      return 'complete';
  }
}

export function resolveRhythmTokens(input: MusicRhythmBlockInput): string[] {
  return input.originalBarTokens ?? input.patternTokens ?? [];
}
